import { render, staticRenderFns } from "./QuizSubmissions.vue?vue&type=template&id=40990c27&"
import script from "./QuizSubmissions.vue?vue&type=script&lang=ts&"
export * from "./QuizSubmissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports